<template>
  <div>
    <Modal v-model="visible" :title="form.id ? '编辑' : '新增'" :footer-hide="true" :mask-closable="false" class="my-modal top">
      <Form ref="form" :model="form" :label-width="80" class="modal-form" v-if="reload" label-position="left">
        <FormItem prop="name" label="模板ID" v-if="form.id && isTop">
          <span>{{ form.id }}</span>
        </FormItem>
        <FormItem prop="name" label="模板名称" :rules="$units.formRule.required('请输入模板名称')">
          <Input v-model="form.name" placeholder="请输入" />
        </FormItem>
        <FormItem prop="type" label="模板类型" :rules="form.id || alone ? {} : $units.formRule.required('请选择模板类型')" v-if="!isTop">
          <span v-if="form.id || alone">
            <template v-if="form.type == 1 && userInfo.levelCode != '10005'">机构模板</template>
            <template v-if="form.type == 2">团队模板</template>
          </span>
          <RadioGroup v-else v-model="form.type">
            <Radio label="1" v-if="userInfo.levelCode != '10005'">机构模板</Radio>
            <Radio label="2">团队模板</Radio>
          </RadioGroup>
        </FormItem>

        <FormItem label="复制上级产品和费率" :label-width="140" v-if="!form.id">
          <i-Switch :value="form.isImportParent" true-value="1" false-value="0" @on-change="form.isImportParent = $event" />
        </FormItem>

        <FormItem label="新产品自动加入模板" :label-width="138">
          <i-Switch :value="form.isExtends" true-value="1" false-value="0" @on-change="form.isExtends = $event" />
        </FormItem>

        <FormItem prop="orgId" label="所属机构" :rules="form.id || alone ? {} : $units.formRule.required('请选择所属机构')" v-if="!isTop">
          <span v-if="form.id || alone">{{ form.orgName }}</span>
          <selectTree v-model="form.orgId" type="3" v-else></selectTree>
        </FormItem>
        <FormItem prop="remarks" label="备注">
          <Input v-model="form.remarks" placeholder="请输入" maxlength="50" show-word-limit type="textarea" />
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="ok" :loading="loading" v-preventReClick>确定</Button>
      </div>
    </Modal>

    <Modal v-model="templateVisible" :mask-closable="false" :closable="true" width="550" :footer-hide="true" class="my-modal top p-b">
      <div class="add-product-success">
        <img src="@static/images/success.png" />
        <div class="title-text">模板已创建</div>
        <div class="info-text">去添加产品吧</div>
        <Button type="primary" ghost @click="templateVisible = false">稍后添加</Button>
        <Button type="primary" @click="addProductClick">添加产品</Button>
      </div>
    </Modal>

    <!-- 新增产品 -->
    <addProduct ref="addProduct" :showSupplier='showSupplier' @success="$emit('success')" :isTop="isTop"></addProduct>
  </div>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
import addProduct from './addProduct';
import { mapState } from 'vuex';
export default {
  components: { addProduct, selectTree },
  props: {
    isTop: null
  },
  data() {
    return {
      showSupplier:true,
      alone: false,
      form: {},
      loading: false,
      reload: false,
      visible: false,
      templateVisible: false,
      templateSaveObj: {}
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    open(form, alone) {
      this.visible = true;
      this.loading = false;
      this.reload = false;
      this.$nextTick(() => {
        this.reload = true;
      });
      this.alone = alone; //是否禁止选择组织
      this.form = form || {};
      if (!form.id) {
        this.form.isImportParent = '0';
        this.form.isExtends = '0';
      }
      console.log('form.showSupplier ',form.showSupplier ,form.showSupplier != undefined)
      if(form.showSupplier != undefined){
        
        this.showSupplier = form.showSupplier;
      }
    },
    ok() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        this.loading = true;
        if (this.form.id) {
          this.$http({
            url: '/buz/template/edit',
            type: 'post',
            data: this.form,
            apiPermissionCode :  this.form.apiPermissionCode
          })
            .then(res => {
              this.loading = false;
              this.visible = false;
              this.$notice.success('编辑模板成功');
              this.$emit('success', res.data);
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          // 新增模板
          this.$http({
            url: '/buz/template/merchants/save',
            type: 'POST',
            data: this.form
          })
            .then(res => {
              this.$emit('success');
              this.visible = false;
              if (this.form.isImportParent == '0') {
                this.templateSaveObj = res.data;
                this.templateVisible = true;
                this.initConfig();
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    initConfig() {
      let params = {
        templateId: this.templateSaveObj.id
      };
      if (this.form.type == 1) {
        // 机构
        params.items = [
          {
            label: '应用机构服务费=上级服务费  X',
            policyType: 1,
            commissionType: 1,
            firstYearValue: 0,
            secondYearValue: 0,
            thirdYearValue: 0,
            fourthYearValue: 0,
            fifthYearValue: 0
          },
          {
            label: '应用机构服务费=上级服务费  X',
            policyType: 2,
            commissionType: 1,
            firstYearValue: 0,
            secondYearValue: 0
          }
        ];
      } else {
        // 团队
        params.items = [
          {
            label: '团队长管理费=上级服务费  X',
            policyType: 1,
            commissionType: 2,
            firstYearValue: 0,
            secondYearValue: 0,
            thirdYearValue: 0,
            fourthYearValue: 0,
            fifthYearValue: 0
          },
          {
            label: '业务员服务费=上级服务费  X',
            policyType: 1,
            commissionType: 3,
            firstYearValue: 0,
            secondYearValue: 0,
            thirdYearValue: 0,
            fourthYearValue: 0,
            fifthYearValue: 0
          },
          {
            label: '团队长管理费=上级服务费  X',
            policyType: 2,
            commissionType: 2,
            firstYearValue: 0,
            secondYearValue: 0
          },
          {
            label: '业务员服务费=上级服务费  X',
            policyType: 2,
            commissionType: 3,
            firstYearValue: 0,
            secondYearValue: 0
          }
        ];
      }
      this.$http({
        url: '/buz/template/initConfig',
        type: 'POST',
        data: params
      });
    },

    // 添加产品
    addProductClick() {
      this.loading = false;
      this.templateVisible = false;
      this.$refs.addProduct.open({
        template: this.templateSaveObj,
        isNewTemplate: true,
        id: this.form.orgId,
        type: this.form.type,
        handleSource: 1
      });
    }
  }
};
</script>
<style lang="scss">
@import './editTemplate.scss';
</style>
